import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import sobre from "../views/sobre.vue"
import aviso from "../views/Aviso.vue"
import ayuda from "../views/ayuda.vue"
import loan from "../views/loan.vue"
import complaints from "../views/complaints.vue"
import fraude from "../views/fraude.vue"

// import home from '../views/newPages/inicio.vue'
// import sobre from "../views/newPages/sobre.vue"
// import aviso from "../views/newPages/Aviso.vue"
// import ayuda from "../views/newPages/FAQ.vue"
// import complaints from "../views/newPages/quejas.vue"
// import fraude from "../views/newPages/fraude.vue"
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/home",
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/about',
    name: 'about',
    component: sobre
  },
  {
    path: '/notice',
    name: 'notice',
    component: aviso
  },
  {
    path: '/help',
    name: 'help',
    component: ayuda
  },
  {
    path: '/loan',
    name: 'loan',
    component: loan
  },
  {
    path: '/complaints',
    name: 'complaints',
    component: complaints
  },
  {
    path: '/fraude',
    name: 'fraude',
    component: fraude
  },
]

const router = new VueRouter({
  // mode: 'history',
  mode: window.location.host == "www.ekecash.pe" ? "history" : "hash",
  base: process.env.BASE_URL,
  routes
})

export default router
